module.exports = __webpack_public_path__ + "static/media/logo-white.4ce6c13b.svg";